import * as React from "react";
const SvgGemAlt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.33366 2.5L6.66699 7.5L10.0003 17.0833L13.3337 7.5L11.667 2.5M2.91699 7.5H17.0837M10.5337 16.7889L17.2003 7.9C17.3079 7.75656 17.3617 7.68484 17.3824 7.60607C17.4007 7.53654 17.4007 7.46346 17.3824 7.39393C17.3617 7.31516 17.3079 7.24344 17.2003 7.1L13.9503 2.76667C13.877 2.66889 13.8403 2.62 13.7939 2.58474C13.7527 2.55351 13.7061 2.53021 13.6564 2.51602C13.6003 2.5 13.5392 2.5 13.417 2.5H6.58366C6.46144 2.5 6.40033 2.5 6.34424 2.51602C6.29456 2.53021 6.24795 2.55351 6.20679 2.58474C6.16032 2.62 6.12366 2.66889 6.05033 2.76667L2.80033 7.1C2.69274 7.24344 2.63895 7.31516 2.61822 7.39393C2.59992 7.46346 2.59992 7.53654 2.61822 7.60607C2.63895 7.68484 2.69274 7.75656 2.80033 7.9L9.46699 16.7889C9.64792 17.0301 9.73839 17.1508 9.8493 17.1939C9.94644 17.2317 10.0542 17.2317 10.1514 17.1939C10.2623 17.1508 10.3527 17.0301 10.5337 16.7889Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgGemAlt;
